import { useEffect, useRef } from "react";

import type { RioTripsFilters } from "@types";
import { buildTripFilters } from "@utils/rioTripOptions";

export type TripFiltersRequestParams = {
  vehicleId?: string | null;
  search?: string | null;
};

export const useTripFiltersRequest = (
  { vehicleId, search }: TripFiltersRequestParams,
  onFiltersChange?: (filters: RioTripsFilters) => void
) => {
  const callbackRef = useRef(onFiltersChange);
  callbackRef.current = onFiltersChange;

  useEffect(() => {
    const filters = buildTripFilters({ vehicleId, search });
    const agendamento = setTimeout(() => callbackRef.current?.(filters), 0);

    return () => clearTimeout(agendamento);
  }, [vehicleId, search]);
};
